export const webSocketEvents = [
  'ESTABLISHMENT_NOTIFICATION',
  'CHECKIN_CHANGE',
  // 'CHECKIN_AWAITING_CONFIRMATION',
];
